import PropTypes from 'prop-types';
import path from 'path';
import React from 'react';
import {intlShape, injectIntl} from 'react-intl';
import Customer from 'models/customer';
import classNames from 'classnames';
import {countries} from 'helpers/constants';

function getEmailStatus(customer, formatMessage) {
  const matches = customer.customerContacts.reduce((total, current) => {
    return total + (current.email === null ? 0 : 1);
  }, 0);

  let title;
  let icon;

  switch (matches) {
    case 0:
      icon = 'bl-scorecard-email-none';
      title = formatMessage({id: 'email.has.provided.email'});
      break;
    case customer.customerContacts.length:
      icon = 'bl-scorecard-email-all';
      title = formatMessage({id: 'email.has.provided.all'});
      break;
    default:
      icon = 'bl-scorecard-email-some';
      title = formatMessage({id: 'email.has.provided.some'});
      break;
  }

  return {title, icon};
}

// Row object
class ScorecardWidget extends React.Component {
  static defaultProps = {
    customer: {
      customerContacts: [],
    },
  };

  static propTypes = {
    areSystemsOnMaintenance: PropTypes.bool,
    customer: PropTypes.instanceOf(Customer).isRequired,
    dealer: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    toggleCustomerSearchModal: PropTypes.func,
    toggleFavourite: PropTypes.func,
  };

  render() {
    const {customer, dealer, areSystemsOnMaintenance} = this.props;
    let {formatMessage} = this.props.intl;

    const {title, icon} = getEmailStatus(customer, formatMessage);

    return (
      <div className="customer-scorecard">
        <div className="row">
          <div className="col-sm-12">
            <h2 style={{marginBottom: 0}}>&nbsp;</h2>
          </div>

          <div className="col-sm-12">
            <table>
              <tbody>
                <tr className="icon-row">
                  <td>
                    <i title={formatMessage({id: dealer.country === countries.CA ?
                        'scorecard.widget.favourite.customer' :
                        'scorecard.widget.favorite.customer'})}
                      className={'icon bl ' + (customer.favourite ? 'bl-star-filled' : 'bl-star')}
                      onClick={this.props.toggleFavourite}
                      data-event-category='User' data-event-action='customer-fav'
                    />
                  </td>

                  <td>
                    <i title={formatMessage({id: 'scorecard.widget.maintenance.truck'})}
                      className={'icon bl truck-icon ' + (areSystemsOnMaintenance ? 'bl-truck-filled' : 'bl-truck')}
                    />
                  </td>

                  <td>
                    <i title={formatMessage({id: 'general.important.notes.flagged'})}
                      className={'icon bl ' + (customer.flag ? 'bl-flag-filled' : 'bl-flag')}
                      onClick={() => window.location.hash = path.join(window.location.hash, 'notes')}
                      data-event-category='User'
                      data-event-action='customer-flag'
                    />
                  </td>

                  <td>
                    <i title={formatMessage({id: 'scorecard.widget.email'})}
                      className={'icon bl ' + icon}
                    />
                  </td>

                  <td>
                    <i title={formatMessage({id: 'general.merge.accounts'})}
                      className={'icon bl bl-merge'}
                      onClick={this.props.toggleCustomerSearchModal}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    );
  }
}

module.exports = injectIntl(ScorecardWidget);
